import React from 'react';
import cx from 'classnames';
import {isEmpty} from 'lodash';

import {createURLWithParams} from '../../util';
import Link from '../../components/Link';

const RelatedItems = ({
  company,
  role,
  category,
  tags,
  className,
  containerClass = 'flex flex-wrap -mx-4 px-4 overflow-scroll scrollbar-hidden gap-y-3 gap-x-1',
  pillClass = 'flex items-center whitespace-nowrap text-gray-900 text-xs font-medium bg-gray-100 border border-transparent rounded-full px-2.5 py-2 transition-all hover:bg-gray-200',
  selectedPillClass = 'bg-gray-200 border-gray-300',
  showTitle = true,
  maxPills = 5,
  onClick = () => {},
}) => {
  let title = 'Popular roles';
  let initialParams = {};
  let pillItems = tags?.role;

  if (role) {
    title = 'Top categories';
    initialParams = {role: role.id};
    const hasCoding = tags?.type?.some((item) => item.id === 'coding');
    const hasAlgorithms = tags?.type?.some((item) => item.id === 'algorithms');
    pillItems = hasCoding && hasAlgorithms
      ? tags.type.filter((item) => item.id !== 'algorithms')
      : tags.type;
  } else if (category) {
    title = 'Related roles';
    initialParams = {type: category.id};
    pillItems = tags?.role;
  } else if (company) {
    title = `Popular roles at ${company.name}`;
    initialParams = {company: company.id};
    pillItems = tags?.role;
  }

  // Only show related items with questions available
  pillItems = pillItems.filter((p) => p.count && p.count > 0);

  // If no items to show, fallback to categories
  if (isEmpty(pillItems)) {
    title = 'Other categories';
    pillItems = tags?.type?.filter((item) => item.id !== 'algorithms');
  }

  return (
    <div className={className}>
      {showTitle && (<p className="text-base font-semibold mb-2">{title}</p>)}
      <div className={containerClass}>
        {pillItems.slice(0, maxPills).map((pill) => (
          <Link
            href={createURLWithParams('/questions', {...initialParams, [pill.type]: pill.id})}
            onClick={() => onClick(pill)}
            className={cx('cursor-pointer', pillClass, {[selectedPillClass]: [role?.id, category?.id, company?.id].includes(pill.id)})}
            key={pill.id}
            shallow
          >
            {pill.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedItems;
